export const sidebarForRole = {
  admin: {
    routes: "all",
    default: "/admin/admins",
  },
  audioAdmin: {
    routes: ["User Management", "Audio Management", "Contact Us"],
    default: "/admin/user",
  },
  stationAdmin: {
    routes: ["Campaign Management", "User Management", "Audio Management", "Contact Us", "Coupons", "Trade Partner"],
    default: "/admin/campaign",
  },
  clusterAdmin: {
    routes: ["Campaign Management", "User Management", "Audio Management", "Contact Us","Trade Partner"],
    default: "/admin/campaign",
  },
  salesUser: {
    routes: ["Campaign Management", "User Management", "Audio Management", "Contact Us", "Coupons", "Trade Partner"],
    default: "/admin/campaign",
  },
  auditAdmin: {
    routes: ["Campaign Management", "User Management", "Audio Management", "Contact Us", "Incentive Management", "Trade Partner"],
    default: "/admin/campaign",
  },
    campaignAdmin: {
    routes: ["Campaign Management", "User Management", "Audio Management", "Contact Us", "Payment Management", "Manage Coupons", "Notification"],
    default: "/admin/campaign",
  },
  financeAdmin: {
    routes: ["Campaign Management", "User Management", "Contact Us", "Payment Management", "Trade Partner"],
    default: "/admin/campaign",
  },
  packageAdmin: {
    routes: ["Package Management", "Rate Management", "Manage Coupons","Trade Partner"],
    default: "/admin/package/frequency",
  },
  ratecardAdmin: {
    routes: ["Package Management", "Rate Management", "Manage Coupons", "Trade Partner"],
    default: "/admin/package/ratecardAdmin",
  },
  couponAdmin: {
    routes: ["Package Management", "Rate Management", "Manage Coupons", "Trade Partner"],
    default: "/admin/package/coupons",
  },
  trafficAdmin: {
    routes: ["User Management", "Campaign Management", "Contact Us", "Trade Partner"],
    default: "/admin/campaign",
  },
  userAdmin: {
    routes: ["Campaign Management", "User Management", "Audio Management", "Contact Us", "Trade Partner", "Role Management"],
    default: "/admin/user",
  },
  user: {
    routes: [
      "System Configuration",
      "User Management",
      "Campaign Management",
      "Package Management",
      "Rate Management",
      "Contact Us",
      "Manage Coupons",
    ],
    default: "/admin/user",
  },
};


// WEBPACK FOOTER //
// ./config/sidebarForRole.js